import scope from '#components/generics/js/selectors/scope.js'
import contract, { selectors } from '@mailobj-browser/front/js/contracts/contract.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import globals from '#utilities/js/ea/globals.js'
import { elements } from './../../styles.js'
import controls from './controls.js'
import controlsMouseMove from './controls/controlsmousemove.js'
import * as gallery from './gallery.js'
import join from './join.js'
import display_videos_list from './layout/sharing/display_cameras_list.js'
import call from './listeners/call.js'
import quality from './listeners/quality.js'
import sharing from './listeners/sharing.js'
import reconnect from './reconnect.js'
import meetscope from './scope.js'
import { meetBlock } from './ui.js'

export default contract({
  [selectors]: {
    ':scope': array([
      meetscope
    ]),
    '.ea_chat__meet_gallery_cameras video': array([
      quality
    ]),
  },
  controls,
  join: array([
    join
  ]),
  reconnect: array([
    reconnect
  ]),
  incall: array([
    controlsMouseMove,
    call,
    sharing
  ]),
  gallery: array([
    gallery.default
  ]),
  sharing: array([
    display_videos_list
  ]),
})

const meetFragment = () => {
  return one('[data-fragment="contracts.chat.mains.meet"]')
}

const meetScope = () => {
  return scope(one('span[data-scope-json]', meetFragment()))
}

const meetGallery = () => {
  return one(`.${elements.meet_gallery}`)
}

globals.ea_meet_elt = meetBlock
globals.ea_meet_elt_gallery = meetGallery
